import React from 'react';
import { Crown, Gem, Feather } from 'lucide-react';
import img1 from "../../assets/interior1.jpg";
import img2 from "../../assets/interior2.jpg";
import img3 from "../../assets/interior3.jpg";
import img4 from "../../assets/interior4.jpg";
import img5 from "../../assets/interior5.jpg";

const designs = [
  { 
    id: 1, 
    title: 'Grand Foyers', 
    category: 'Entrance', 
    image: img1 
  },
  { 
    id: 2, 
    title: 'Royal Dining Halls', 
    category: 'Dining', 
    image: img2 
  },
  { 
    id: 3, 
    title: 'Bespoke Art Walls', 
    category: 'Decor', 
    image: img3 
  },
  { 
    id: 4, 
    title: 'Staircase Elegance', 
    category: 'Architecture', 
    image: img4
  },
];

const LuxuryInteriors = () => {
  return (
    <div className="font-sans text-gray-800 bg-white">
      {/* Hero */}
       <div
        className="relative h-[60vh] w-full bg-cover bg-center"
        style={{ backgroundImage: `url(${img5})` }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h4 className="text-amber-500 font-bold tracking-widest uppercase mb-3">Beyond Ordinary</h4>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">Luxury Interiors</h1>
          <p className="text-gray-200 text-lg max-w-xl">Curating timeless elegance for every corner of your estate.</p>
        </div>
      </div>

      {/* Intro */}
      <section className="py-16 px-6 bg-white text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">Grandeur & Grace</h2>
        <div className="w-20 h-1 bg-amber-500 mx-auto mb-6"></div>
        <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
          From breathtaking chandeliers to hand-carved moldings, our luxury interior services cover the full spectrum of home design. We focus on the flow, light, and texture to create homes that feel like palaces.
        </p>
      </section>

      {/* Gallery */}
      <section className="py-16 bg-gray-50 px-6">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-3xl font-serif font-bold text-gray-900 mb-8 text-center md:text-left">Signature Spaces</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {designs.map((design) => (
              <div key={design.id} className="group relative overflow-hidden shadow-lg cursor-pointer rounded-sm">
                <div className="h-80 overflow-hidden">
                  <img src={design.image} alt={design.title} className="w-full h-full object-cover transform group-hover:scale-110 transition duration-700"/>
                </div>
                <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/90 to-transparent p-6 pt-20">
                  <p className="text-amber-400 text-xs tracking-widest uppercase mb-1">{design.category}</p>
                  <h4 className="text-2xl font-serif text-white">{design.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 px-6 bg-stone-900 text-white">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center">
            <Crown className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Royal Aesthetics</h4>
            <p className="text-gray-400 text-sm">Inspired by palaces and high-end hotels.</p>
          </div>
          <div className="flex flex-col items-center">
            <Gem className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Detail Oriented</h4>
            <p className="text-gray-400 text-sm">From flooring patterns to ceiling cornices.</p>
          </div>
          <div className="flex flex-col items-center">
            <Feather className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Bespoke Decor</h4>
            <p className="text-gray-400 text-sm">Custom-made art pieces and furniture.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 text-center bg-white">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6">Create Your Masterpiece</h2>
        <button className="bg-amber-500 hover:bg-amber-600 text-white text-lg font-semibold px-8 py-3 rounded-sm transition shadow-lg">Consult a Designer</button>
      </section>
    </div>
  );
};

export default LuxuryInteriors;